import { displayDateByString } from '../../../../../../../../../utils/globals/date'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import { OnChangeSearchBarAddQuoteCustomer, QuoteOrderModelTypeExtended } from '../../types'

interface SearchBarQuoteCustomerResultsProps {
    quotes: QuoteOrderModelTypeExtended[] | null
    onSelectQuote: OnChangeSearchBarAddQuoteCustomer
    className?: string
}

const SearchBarQuoteCustomerResults: React.FC<SearchBarQuoteCustomerResultsProps> = ({ quotes, onSelectQuote, className }) => {
    const renderThis: JSX.Element[] = []
    if (!quotes) {
        return null
    }
    for (const key in quotes) {
        const quote = quotes[key]
        renderThis.push(<SearchedQuoteCustomer key={key} quote={quote} onSelectQuote={onSelectQuote} />)
    }
    return (
        <div className={'searched_input_products ' + (className || '')}>
            <div className='results_searched_products'>
                {renderThis}
            </div>
        </div>
    )
}

interface SearchedQuoteCustomerProps {
    onSelectQuote: OnChangeSearchBarAddQuoteCustomer
    quote: QuoteOrderModelTypeExtended
}

const SearchedQuoteCustomer: React.FC<SearchedQuoteCustomerProps> = ({ quote, onSelectQuote }) => {
    const customerName = quote?.Customer?.name
    const reference = quote.full_assigned_number
    const version = quote.version
    const workingCenterName = quote.WorkingCenter?.name
    const date = displayDateByString(quote.processed_date || quote.createdAt)
    let fields: TwinDictionary = {
        main: customerName,
        secondary: reference + '/' + version,
        date: date
    }
    return (
        <div className='searched_product' onClick={() => onSelectQuote(quote)}>
            <span className='text-green-00 font-medium'>{fields.secondary}</span>
            <span className='mx-5'>-</span>
            <span className='twin_elipsis'>{fields.main}</span>
            <span className='mx-5'>-</span>
            <span>{fields.date}</span>
            <span className='mx-5'>-</span>
            <span className='twin_elipsis'>{workingCenterName}</span>
        </div>
    )
}

export default SearchBarQuoteCustomerResults